import { action, observable } from 'mobx';
import {
    ITaskResponse,
    ITaskCountResponse,
    TaskStatus
} from '~/components/Tasks/types/tasks.types';
import { TTaskGroup } from '~/apps/main/Workspace/TasksTab/workspace-tasks.types';
import { getUpdatedTaskStatus } from '~/components/Tasks/tasks.utils';

export class BaseTasksStore {
    @observable taskList: ITaskResponse[] = [];
    @observable taskGroups: TTaskGroup[] = [];
    @observable hasLoadedTasks = false;
    @observable hasLoadedTaskGroups = false;
    @observable taskCount: ITaskCountResponse = {
        all: 0,
        approvals: 0,
        completed: 0,
        overdue: 0,
        tasks: 0,
        this_week: 0,
        today: 0,
        total: 0
    };

    @action.bound
    setTaskList(taskList: ITaskResponse[]) {
        this.taskList = taskList;
    }

    @action.bound
    setTaskGroups(taskGroups: TTaskGroup[]) {
        this.taskGroups = taskGroups ?? [];
    }

    @action.bound
    setHasLoadedTasks(hasLoaded: boolean) {
        this.hasLoadedTasks = hasLoaded;
    }

    @action.bound
    setHasLoadedTaskGroups(hasLoaded: boolean) {
        this.hasLoadedTaskGroups = hasLoaded;
    }

    @action.bound
    setTaskCount(taskCount: ITaskCountResponse) {
        this.taskCount = taskCount;
    }

    isAutomationTask(task: ITaskResponse) {
        return task.source === 'workflow';
    }

    isTaskCompleted(task: ITaskResponse) {
        const updatedTaskStatus = getUpdatedTaskStatus(task);
        return (
            updatedTaskStatus === TaskStatus.COMPLETED ||
            updatedTaskStatus === TaskStatus.APPROVED
        );
    }
}
